import { Link } from 'react-router-dom'
import { all_routes } from '../../router/all_routes'
import ImageWithBasePath from '../../../core/common/imageWithBasePath'
import { useSelector } from 'react-redux'
import BackendImage from '../../../core/common/backendImage'

const ProfileCard = () => {

    const user = useSelector((state: any) => state.auth.user);
    const institution = user?.institution;
    
    return (
        <div className="profile-card overflow-hidden bg-blue-gradient2 mb-5 p-5">
            <div className="profile-card-bg">
                <ImageWithBasePath
                    src="assets/img/bg/card-bg-01.png"
                    className="profile-card-bg-1"
                    alt=""
                />
            </div>
            <div className="row align-items-center row-gap-3">
                <div className="col-lg-6">
                    <div className="d-flex align-items-center">
                        <span className="avatar avatar-xxl avatar-rounded me-3 border border-white border-2 position-relative">
                            <BackendImage src={institution?.image?.url} />
                            <span className="verify-tick">
                                <i className="isax isax-verify5" />
                            </span>
                        </span>
                        <div>
                            <h5 className="mb-1 text-white d-inline-flex align-items-center">
                                <Link to={all_routes.institutionDetails.replace(":id", institution?.id || '')}>{institution?.schoolName || ''}</Link>
                            </h5>
                            <p className="text-light">Institution</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProfileCard